export enum AcceptedLocale {
  /** Brasil */
  ptBR = 'pt-br',
  /** Portugal */
  ptPT = 'pt-pt',
  /** Espanha */
  esES = 'es-es',
  /** Argentina */
  esAR = 'es-ar',
  /** Uruguai */
  esUY = 'es-uy',
  /** Paraguai */
  esPY = 'es-py',
  /** Chile */
  esCL = 'es-cl',
  /** Colômbia */
  esCO = 'es-co',
  /** Peru */
  esPE = 'es-pe',
  /** Bolívia */
  esBO = 'es-bo',
  /** Equador */
  esEC = 'es-ec',
  /** Estados Unidos */
  enUS = 'en-us',
  /** Inglaterra (Grã Bretanha) */
  enGB = 'en-gb',
  /** Canadá */
  endCA = 'en-ca',
}
